import React from "react";
import {isUserAdmin} from "../../utils/userUtils";

const TournamentKnockoutSection = ({
    visible,
    knockoutPhaseExists,
    bracketPlanned,
    activeView,
    allGroupsCompleted,
    user,
    onInitializeKnockoutPhase,
    onShowKnockoutPhase,
    onShowGroupPhase,
}) => {
    if (!visible) {
        return null;
    }

    const userIsAdmin = isUserAdmin(user);

    return (
        <div className="groupphase-section">
            <h2>K.O.-Phase</h2>
            {knockoutPhaseExists ? (
                <div style={{display: "flex", gap: "12px", alignItems: "center"}}>
                    <span style={{color: "#4CAF50", fontWeight: "500"}}>
                        ✓ K.O.-Phase ist bereits initialisiert
                    </span>
                    {activeView === "knockout" ? (
                        <button
                            onClick={onShowGroupPhase}
                            className="group-button"
                        >
                            Zur Gruppenphase
                        </button>
                    ) : (
                        <button
                            onClick={onShowKnockoutPhase}
                            className="group-button group-button-active"
                        >
                            K.O.-Phase anzeigen
                        </button>
                    )}
                </div>
            ) : bracketPlanned ? (
                <div style={{display: "flex", gap: "12px", alignItems: "center", flexWrap: "wrap"}}>
                    <span style={{color: "#666"}}>
                        K.O.-Spielplan ist vorbereitet, Teilnehmer stehen noch nicht fest
                    </span>
                    {activeView === "knockout" ? (
                        <button
                            onClick={onShowGroupPhase}
                            className="group-button"
                        >
                            Zur Gruppenphase
                        </button>
                    ) : (
                        <button
                            onClick={onShowKnockoutPhase}
                            className="group-button group-button-active"
                        >
                            K.O.-Spielplan ansehen
                        </button>
                    )}
                    {userIsAdmin && allGroupsCompleted && (
                        <button
                            onClick={onInitializeKnockoutPhase}
                            className="group-button"
                            style={{
                                backgroundColor: "#4CAF50",
                                color: "white",
                                border: "none",
                                cursor: "pointer",
                            }}
                        >
                            Gruppenphase abschließen
                        </button>
                    )}
                </div>
            ) : allGroupsCompleted ? (
                <div style={{display: "flex", gap: "12px", alignItems: "center"}}>
                    <span style={{color: "#4CAF50"}}>
                        ✓ Alle Gruppenspiele abgeschlossen
                    </span>
                    {userIsAdmin && (
                        <button
                            onClick={onInitializeKnockoutPhase}
                            className="group-button"
                            style={{
                                backgroundColor: "#4CAF50",
                                color: "white",
                                border: "none",
                                cursor: "pointer",
                            }}
                        >
                            K.O.-Phase starten
                        </button>
                    )}
                </div>
            ) : (
                <div style={{color: "#666", fontStyle: "italic"}}>
                    Schließen Sie erst alle Gruppenspiele ab, um die K.O.-Phase zu starten
                </div>
            )}
        </div>
    );
};

export default TournamentKnockoutSection;

